import { memo, useCallback, useState } from 'react';
import { getFormFieldId } from '../../domain/form-provider';
import Badge from '../Badge';
import ColorPicker from './color-picker/ColorPicker';
import tinycolor from 'tinycolor2';
import { IColor } from '../../interfaces';

interface IFormColorControl {
    title: string,
    rgbaColor: IColor,
    onChange: (color: IColor) => void,
}

/**
 * Color Picker Control.
 */
const FormColorControl = (props: IFormColorControl) => {

    const [id] = useState(getFormFieldId(props.title));

    const { title, rgbaColor, onChange } = props;

    const getBadgeColorHex = () => {
        const color = tinycolor({ r: rgbaColor.r, g: rgbaColor.g, b: rgbaColor.b, a: rgbaColor.a });

        if(rgbaColor.a >= 1){
            return color.toHexString();
        }

        return color.toHex8String();
    };

    const onColorChange = useCallback((updateColor: IColor) => {
        onChange(updateColor);
    }, [onChange]);

    return (
        <div className="flex flex-col mb-4">
            <label htmlFor={ id } className="mb-2">{ title }</label>
            <div className="flex">
                <ColorPicker
                    {...rgbaColor}
                    onChange={ onColorChange }
                />
                <Badge
                    text={ getBadgeColorHex() }
                    style={{
                        minWidth: '70px'
                    }}
                />
            </div>
        </div>
    )
};

export  default memo(FormColorControl);